var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`pa-2 col-${_vm.col.sm} col-lg-${_vm.col.lg}`,style:({ height: _vm.layout.height ? _vm.layout.height : '' })},[_vm._t("default",function(){return [_vm._v("Empty")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }